"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIdPipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL LIBRARY BITS
const user_service_1 = require("./user.service");
const users_service_1 = require("./users.service");
const permission_service_1 = require("./permission.service");
const admin_service_1 = require("./admin.service");
const user_1 = require("./user");
let UserIdPipe = class UserIdPipe {
    constructor(_user, _users, _permission, _admin) {
        this._user = _user;
        this._users = _users;
        this._permission = _permission;
        this._admin = _admin;
    }
    transform(value) {
        let user = this._user.get();
        let permission = this._permission.get();
        let searchedUser = new user_1.User;
        if (typeof value == 'number') {
            if (user.id == value) {
                return user.email;
            }
            searchedUser = this._users.getUserById(value);
            if (searchedUser) {
                if (searchedUser.email.toLowerCase().indexOf('brealtime') > 0) {
                    let userRoles = searchedUser.roles.map(role => { return role.slug; });
                    for (let role in searchedUser.roles) {
                        if (!permission['viewing-rights-user-role--' + searchedUser.roles[role]]) {
                            return 'bRealTime';
                        }
                    }
                    return searchedUser.email;
                }
            }
            return value;
        }
        else if (typeof value == 'string') {
            searchedUser = this._users.getUserByEmail(value);
            if (user.email == value) {
                return user.email;
            }
            if (!searchedUser.email) { // email may be blank if user doesn't have admin-users--view_all
                return 'bRealTime';
            }
            if (searchedUser) {
                if (searchedUser.email.toLowerCase().indexOf('brealtime') > 0) {
                    let userRoles = searchedUser.roles.map(role => {
                        return role.slug;
                    });
                    for (let role in userRoles) {
                        if (!permission['viewing-rights-user-role--' + userRoles[role]]) {
                            return 'bRealTime';
                        }
                    }
                    return searchedUser.email;
                }
            }
            return value;
        }
        return value;
    }
};
exports.UserIdPipe = UserIdPipe;
exports.UserIdPipe = UserIdPipe = __decorate([
    (0, core_1.Pipe)({ name: 'userId' }),
    __metadata("design:paramtypes", [user_service_1.UserService,
        users_service_1.UsersService,
        permission_service_1.PermissionService,
        admin_service_1.AdminService])
], UserIdPipe);
//# sourceMappingURL=user-id.pipe.js.map